import { render } from "./SignForm.vue?vue&type=template&id=2aa7cc96&ts=true"
import script from "./SignForm.vue?vue&type=script&lang=ts"
export * from "./SignForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/SignForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2aa7cc96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2aa7cc96', __exports__)) {
    api.reload('2aa7cc96', __exports__)
  }
  
  module.hot.accept("./SignForm.vue?vue&type=template&id=2aa7cc96&ts=true", () => {
    api.rerender('2aa7cc96', render)
  })

}


export default __exports__